import {useTranslation} from "react-i18next";
import NestedList, {NestedListT} from "./common/NestedList";


const OtherData = () => {
    const {t} = useTranslation();
    const list:NestedListT = [
        t('otherData.content.location'),
        t('otherData.content.car'),
        t('otherData.content.english')
    ]

    return (

        <div className={"w-full text-left"}>
            <NestedList paraphs={list}/>
        </div>
    )
}

export default OtherData